var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 5.3325H3.21995L6.47328 2.07917C6.73328 1.81917 6.73328 1.3925 6.47328 1.1325C6.21328 0.8725 5.79328 0.8725 5.53328 1.1325L1.13995 5.52583C0.879946 5.78583 0.879946 6.20583 1.13995 6.46583L5.53328 10.8592C5.79328 11.1192 6.21328 11.1192 6.47328 10.8592C6.73328 10.5992 6.73328 10.1792 6.47328 9.91917L3.21995 6.66583H10.6666C11.0333 6.66583 11.3333 6.36583 11.3333 5.99917C11.3333 5.6325 11.0333 5.3325 10.6666 5.3325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.93775e2369e928d3cd33f8b87ff6adff.svg";
export { ForwardRef as ReactComponent };